module.exports = __webpack_public_path__ + "static/media/hero-sm.1ad877af.jpg";